import { render, staticRenderFns } from "./AlarmLink.vue?vue&type=template&id=cc0d8346&"
import script from "./AlarmLink.vue?vue&type=script&lang=ts&"
export * from "./AlarmLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports